// @core/api/endpoints/workflow/list_pipeline_run_as_requests.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPipelineRunAsRequestsRequest,
  ListPipelineRunAsRequestsResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * List visible execution identity requests
 * Returns a paginated list of pipeline run as requests. Supports filtering and sorting.
 */
export async function ListPipelineRunAsRequests(
  params?: ListPipelineRunAsRequestsRequest,
  options?: RequestOptions
): Promise<ListPipelineRunAsRequestsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/run-as-requests`;
  const requestOptions = options;
  return client.get<ListPipelineRunAsRequestsResponse>(requestPath, { ...requestOptions, params });
}
